<phx-dialog
  [phxFullHeight]="true"
  [phxBackdrop]="phxBackdrop && !isMobileView"
  [phxPlacement]="isMobileView ? 'bottom' : 'right'"
  [phxOpen]="phxOpen"
  (phxOpenChange)="phxOpenChange.emit($event)"
  (phxBackdropClicked)="onBackdropClicked()"
  (phxKeydown)="onKeydown($event)"
>
  <div
    class="phx-drawer"
    [ngClass]="[
      phxInfoFooter ? 'phx-drawer-info-footer' : '',
      phxNavigationIcon ? 'phx-drawer-navigation' : '',
      phxOverlayClass || '',
    ]"
  >
    <div class="phx-drawer-header">
      <ng-content select="[phx-drawer-header]"></ng-content>
      <ng-content select="[phx-drawer-filters]"></ng-content>
      <button
        class="phx-drawer-close-btn"
        phx-icon-button
        [phxIcon]="phxNavigationIcon ? BackIcon : CloseIcon"
        [phxIconButtonSize]="isMobileView ? 'extra-large' : 'small'"
        [disabled]="phxCloseIconDisabled"
        (click)="closeIconClicked()"
      ></button>
    </div>
    <ng-content select="[phx-drawer-body]"></ng-content>
    <ng-content select="[phx-drawer-footer]"></ng-content>
  </div>
</phx-dialog>
